import React, { useState } from 'react';
import { Box, Typography, IconButton, Collapse, Paper } from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';

const ExpandableSection = ({ title, children }) => {
    const [open, setOpen] = useState(true);

    return (
        <Paper elevation={2} sx={{ mb: 2 }}>
            <Box display="flex" alignItems="center" px={2} py={1} bgcolor="#f5f5f5">
                <IconButton onClick={() => setOpen(!open)}>
                    {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                </IconButton>
                <Typography variant="h6" ml={1}>{title}</Typography>
            </Box>
            <Collapse in={open}>
                <Box p={2}>
                    {children}
                </Box>
            </Collapse>
        </Paper>
    );
};

export default ExpandableSection;
